export default {
  setData(state, { payload }) {
    state.allData = payload.data.list;
  },
  setItem(state, { payload }) {
    state.item = payload.data.data;
  },
  setCategory(state, data) {
    state.allCategory = data;
  },
  setFlashErrorMessage(state, payload) {
    state.flashErrorMessage = payload;
    state.flashError = payload !== '';
  },
  clearData(state) {
    state.allData = [];
    state.totalData = 0;
  },
  clearErrors(state) {
    state.errors = [];
  },
  setErrors(state, payload) {
    state.errors = payload;
  },
  setTotalData(state, { payload }) {
    state.totalData = parseInt(payload.data.countdata, 10);
    state.totalPage = parseInt(payload.data.totalPage, 10);
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  setIntervalExport(state, payload) {
    state.intervalExport = payload;
  },
  setExportData(state, payload) {
    state.exportId = payload.export_id;
    state.countDataExport = payload.count_data;
  },
  setStateVariable(state, { payload, variable }) {
    state[variable] = payload;
  },
  setCancelation(state, payload) {
    state.requestData = payload;
  },
  setIntervalRefund(state, payload) {
    state.intervalRefund = payload;
  },
  setRefundData(state, payload) {
    state.refundId = payload.export_id;
    state.countDataRefund = parseInt(payload.count_data, 10);
  },
  setShowProgressBar(state, payload) {
    state.showProgressBar = payload;
  },
  setProgressTitle(state, title) {
    state.progressTitle = title;
  },
  setProgressColor(state, color) {
    state.progressColor = color;
  },
  setPercentage(state, percentage) {
    state.percentage = percentage;
  },
  setFailedResponse(state, payload) {
    state.isFailedResponse = payload;
  },
};
